import { Form, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { MitigationSectionProps } from ".";
import { InfoCircleIcon, MinusIcon, PlusIcon } from "../../../../../atoms/icon";

const SourceSection = (props: MitigationSectionProps) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            <Form.List
                name="internal"
            >

                {(fields, { add, remove }, { errors }) => (
                    <div className="form-list">
                        {fields.map((field, index) => (
                            <Form.Item
                                key={field.key}
                                label={index === 0 ?
                                    t("ScenarioMitigation.lbInternal") : null}
                                tooltip={index === 0 ? { title: t("ScenarioMitigation.lbInternal"), icon: <InfoCircleIcon /> } : null}
                            >
                                <Form.Item
                                    name={[field.name, "id"]}
                                    hidden={true}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    {...field}
                                    name={[field.name, "name"]}
                                >
                                    <Input />
                                </Form.Item>
                                <span className="form-list-action">
                                    <PlusIcon onClick={() => add()} />
                                </span>
                                <span className="form-list-action">
                                    {
                                        index > 0 && <MinusIcon onClick={() => { remove(field.name) }} />
                                    }
                                </span>
                            </Form.Item>
                        ))}

                    </div>
                )}
            </Form.List>

            <Form.List
                name="external"
            >

                {(fields, { add, remove }, { errors }) => (
                    <div className="form-list">
                        {fields.map((field, index) => (
                            <Form.Item
                                className="form-list-item"
                                key={field.key}
                                label={index === 0 ?
                                    t("ScenarioMitigation.lbExternal") : null}
                                tooltip={index === 0 ? { title: t("ScenarioMitigation.lbExternal"), icon: <InfoCircleIcon /> } : null}
                            >
                                <Form.Item
                                    name={[field.name, "id"]}
                                    hidden={true}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    {...field}
                                    name={[field.name, "name"]}
                                >
                                    <Input />
                                </Form.Item>
                                <span className="form-list-action">
                                    <PlusIcon onClick={() => add()} />
                                </span>
                                <span className="form-list-action">
                                    {
                                        index > 0 && <MinusIcon onClick={() => { remove(field.name) }} />
                                    }
                                </span>
                            </Form.Item>
                        ))}

                    </div>
                )}
            </Form.List>

        </div>
    )
}

export default SourceSection;